import { Fragment, useState } from "react"
import PropTypes from "prop-types"
import { map, get } from "lodash"
import { Card, List, ListSubheader, ListItemButton, ListItemText, ListItemIcon, ListItemSecondaryAction, Collapse, IconButton, Badge } from "@mui/material"
import { ExpandMore, ExpandLess, CheckBox, CheckBoxOutlineBlank, RotateLeft } from "@mui/icons-material"
import { getDynamicFilters, areFiltersResetable, getNbActiveFilters, getFilterTitle } from "modules/data-cloud/helpers"

const Filter = ({ datasets, filters, setFilter, reset }) => {
  const [open, setOpen] = useState({})

  const dynamicFilters = getDynamicFilters(datasets)

  const handleSetFilter = (type, value) => () => {
    const isActive = !get(filters, [type, value], false)
    setFilter({ type, value, isActive })
  }

  return (
    <Card className="filters" square elevation={1}>
      <div className="content">
        <List
          component="div"
          aria-labelledby="filter-list"
          subheader={
            <ListSubheader component="div" id="filter-list">
              <span>Dynamic Filters</span>
              <Badge className="solo-badge" badgeContent={getNbActiveFilters(filters, dynamicFilters)} color="primary" />
              {areFiltersResetable(filters, dynamicFilters)
                && <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    size="small"
                    aria-label="reset"
                    onClick={(event) => {
                      event.stopPropagation()
                      reset()
                    }}
                  >
                    <RotateLeft color="primary" />
                  </IconButton>
                </ListItemSecondaryAction>}
            </ListSubheader>
          }
        >
          {map(dynamicFilters, (category, key) => <Fragment key={key}>
            <ListItemButton key={key} onClick={() => setOpen({ ...open, [key]: !get(open, key, true) })}>
              <ListItemText primary={getFilterTitle(key)} />
              {open[key] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse key={`${key}-collapse`} in={get(open, key, true)} timeout="auto" unmountOnExit>
              <List component="div">
                {map(category, ({ type, value }) => <ListItemButton key={value} onClick={handleSetFilter(type, value)}>
                  <ListItemIcon className="small-padding">
                    {get(filters, [type, value]) ? <CheckBox color="primary" /> : <CheckBoxOutlineBlank /> }
                  </ListItemIcon>
                  <ListItemText primary={value} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>)}
              </List>
            </Collapse>
          </Fragment>,
          )}

        </List>
      </div>
    </Card>
  )
}

Filter.propTypes = {
  datasets: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
}

export default Filter
